import 'amfe-flexible'
import {
    createApp
} from "vue";
import App from "./App.vue";
import router from './router'

import "@/assets/css/global.css";
import "@/assets/less/app.less";
import "@/assets/css/font.css";

const app = createApp(App);
app.use(router).mount('#app')